/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FireControllerInformation from './FireControllerInformation';

/**
 * The FireControllerDevice model module.
 * @module model/FireControllerDevice
 * @version 1.1.0
 */
class FireControllerDevice {
    /**
     * Constructs a new <code>FireControllerDevice</code>.
     * Complete Fire Controller device information
     * @alias module:model/FireControllerDevice
     * @param fireControllerId {String} The ID of the Fire Controller
     * @param fireControllerInformation {module:model/FireControllerInformation} 
     */
    constructor(fireControllerId, fireControllerInformation) { 
        
        FireControllerDevice.initialize(this, fireControllerId, fireControllerInformation);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, fireControllerId, fireControllerInformation) { 
        obj['fireControllerId'] = fireControllerId;
        obj['fireControllerInformation'] = fireControllerInformation;
    }

    /**
     * Constructs a <code>FireControllerDevice</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireControllerDevice} obj Optional instance to populate.
     * @return {module:model/FireControllerDevice} The populated <code>FireControllerDevice</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireControllerDevice();

            if (data.hasOwnProperty('fireControllerId')) {
                obj['fireControllerId'] = ApiClient.convertToType(data['fireControllerId'], 'String');
            }
            if (data.hasOwnProperty('fireControllerInformation')) {
                obj['fireControllerInformation'] = FireControllerInformation.constructFromObject(data['fireControllerInformation']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireControllerDevice</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireControllerDevice</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FireControllerDevice.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['fireControllerId'] && !(typeof data['fireControllerId'] === 'string' || data['fireControllerId'] instanceof String)) {
            throw new Error("Expected the field `fireControllerId` to be a primitive type in the JSON string but got " + data['fireControllerId']);
        }
        // validate the optional field `fireControllerInformation`
        if (data['fireControllerInformation']) { // data not null
          FireControllerInformation.validateJSON(data['fireControllerInformation']);
        }

        return true;
    }


}

FireControllerDevice.RequiredProperties = ["fireControllerId", "fireControllerInformation"];

/**
 * The ID of the Fire Controller
 * @member {String} fireControllerId
 */
FireControllerDevice.prototype['fireControllerId'] = undefined;

/**
 * @member {module:model/FireControllerInformation} fireControllerInformation
 */
FireControllerDevice.prototype['fireControllerInformation'] = undefined;






export default FireControllerDevice;

